var render = function () {
  var _vm$commonInfo, _vm$commonInfo2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "inner fixed"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/index.html"
    }
  }, [_c('img', {
    staticClass: "logo_01",
    attrs: {
      "src": (_vm$commonInfo = _vm.commonInfo) === null || _vm$commonInfo === void 0 ? void 0 : _vm$commonInfo.photo1
    }
  }), _c('img', {
    staticClass: "logo_02",
    attrs: {
      "src": (_vm$commonInfo2 = _vm.commonInfo) === null || _vm$commonInfo2 === void 0 ? void 0 : _vm$commonInfo2.photo2
    }
  })])]), _c('div', {
    staticClass: "nav_phone_btn",
    class: {
      visible_nav: _vm.showNav
    },
    on: {
      "click": _vm.toggleNav
    }
  }, [_c('span')]), _c('nav', {
    staticClass: "nav fixed"
  }, [_c('div', {
    staticClass: "rr_top"
  }, [_c('div', {
    staticClass: "mem",
    on: {
      "mouseenter": function ($event) {
        _vm.showMenu = true;
      }
    }
  }, [_vm.userInfo ? _c('i', {
    staticClass: "icon-ren fnt_20"
  }) : _vm._e(), !_vm.userInfo ? _c('i', {
    staticClass: "icon-ren fnt_20",
    on: {
      "click": function ($event) {
        return _vm.logInAndlogOutClick('logIn');
      }
    }
  }) : _vm._e(), _vm.userInfo ? _c('em', {
    staticClass: "fnt_14 userInfoName"
  }, [_vm._v("会员：" + _vm._s(_vm.userInfo.title))]) : _vm._e(), _vm.userInfo ? _c('i', {
    staticClass: "icon-icon fnt_20"
  }) : _vm._e(), _vm.userInfo ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showMenu,
      expression: "showMenu"
    }],
    staticClass: "mem_xiala"
  }, [_c('router-link', {
    attrs: {
      "to": "/member/index"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("会员中心")])]), _c('router-link', {
    attrs: {
      "to": "/product/shoppingCart"
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("购物车")])]), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.logInAndlogOutClick('logOut');
      }
    }
  }, [_vm._v("退出登录")])], 1) : _vm._e(), !_vm.userInfo ? _c('em', {
    staticClass: "fnt_14",
    on: {
      "click": function ($event) {
        return _vm.logInAndlogOutClick('logIn');
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("登录")])]) : _vm._e()]), _vm._m(0), _c('div', {
    staticClass: "search_wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.iptValue,
      expression: "iptValue"
    }],
    staticClass: "search_box_text",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": _vm.iptValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.iptValue = $event.target.value;
      }
    }
  }), _c('button', {
    staticClass: "search_box_button fnt_20",
    on: {
      "click": _vm.searchBtn
    }
  }, [_c('i', {
    staticClass: "icon-sousuo"
  })])])]), _c('ul', {
    staticClass: "fixed"
  }, [_vm._m(1), _c('li', {
    class: {
      on: !_vm.isAuthPage
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.productListBtn
    }
  }, [_vm._v("产品中心"), _c('em')])]), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5)])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ser fnt_20"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "icon-sousuo"
  })])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "/index.html"
    }
  }, [_vm._v("首页"), _c('em')])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "/application/index.html"
    }
  }, [_vm._v("应用场景"), _c('em')])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "/service/index.html"
    }
  }, [_vm._v("服务"), _c('em')])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "/cooperation/index.html"
    }
  }, [_vm._v("合作"), _c('em')])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('span', {
    staticClass: "icon-icon"
  }), _c('a', {
    attrs: {
      "href": "/resource/index.html"
    }
  }, [_vm._v("资源中心"), _c('em')]), _c('div', {
    staticClass: "navlist fixed"
  }, [_c('dl', {
    staticClass: "fixed"
  }, [_c('dd', [_c('a', {
    attrs: {
      "href": "/resource/product.html"
    }
  }, [_vm._v("产品与资料")])]), _c('dd', [_c('a', {
    attrs: {
      "href": "/resource/knowledge.html"
    }
  }, [_vm._v("知识中心")])]), _c('dd', [_c('a', {
    attrs: {
      "href": "/resource/industry.html"
    }
  }, [_vm._v("产业版图")])])])])]);
}]

export { render, staticRenderFns }